import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import * as Popover from "@/components/ui/popover";
import type { MenuItem } from "../Header.types";
import { MENU_ITEMS } from "../const";

export function MoreVertMenu() {
  const navigate = useNavigate();
  const [popoverOpen, setPopoverOpen] = useState(false);

  const handleMenuItemClick = (path?: string) => {
    if (path) {
      navigate({ to: path });
    }
    setPopoverOpen(false);
  };

  const renderMenuItem = (item: MenuItem) => (
    <button
      key={item.title}
      type="button"
      onClick={() => handleMenuItemClick(item.path)}
      className="flex items-center gap-4 p-2 rounded-md hover:bg-secondary-100 text-left"
    >
      {item.icon}
      <div className="flex flex-col">
        <p className="text-[14px] font-medium text-[#000000]">{item.title}</p>
        <p className="text-[14px] font-normal text-[rgba(0,0,0,0.5)]">
          {item.subtitle}
        </p>
      </div>
    </button>
  );

  return (
    <Popover.Root open={popoverOpen} onOpenChange={setPopoverOpen}>
      <Popover.Trigger asChild>
        <button
          className={`h-6 w-6 flex items-center justify-center text-[#FFFFFF] cursor-pointer hover:opacity-50 active:opacity-50 ${
            popoverOpen ? "opacity-50" : ""
          }`}
        >
          <span className="material-symbols-outlined text-2xl leading-none">
            more_vert
          </span>
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          className="z-50 w-80 rounded-[16px] border border-secondary-300 bg-white-primary py-2 px-2 shadow-md"
          sideOffset={6}
          align="center"
        >
          <Popover.Arrow className="w-6 h-3 -translate-y-[1px] fill-white-primary" />
          <div className="flex flex-col">
            {MENU_ITEMS.map((item) => renderMenuItem(item))}
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
